import * as React from 'react';
import className from 'classnames';

import './Loading.scss';

interface Props {
  text?: string;
  isWrapped?: boolean;
}

const Loading: React.FC<Props> = ({
  text,
  isWrapped,
}: Props): React.ReactElement => {
  const loadingClasses = className('Loading', {
    'Loading Loading--isWrapped': isWrapped,
  });

  return (
    <div className={loadingClasses}>
      <div className="Loading__circle" />
      <div className="Loading__text">{text}</div>
    </div>
  );
};

Loading.defaultProps = { text: 'Loading', isWrapped: false };

export default Loading;
